import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLang } from "../lib/lang";
import { pages } from "../lib/pagesCopy";
import { Reveal, Eyebrow } from "./Reveal";

/* Shared top section for inner pages: breadcrumb, eyebrow, H1 and intro. */
export const PageHero = ({ eyebrow, title, text, testid }) => {
  const { lang } = useLang();
  return (
    <section className="relative overflow-hidden bg-ink pb-20 pt-10 text-white lg:pb-28 lg:pt-14" data-testid={testid}>
      <div className="dot-grid pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-48 -top-48 h-[460px] w-[460px] rounded-full bg-sun/90 max-sm:-right-64" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-white/80">
          <Link to="/" className="hover:text-white" data-testid="breadcrumb-home">{pages[lang].crumbs}</Link>
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
          <span aria-current="page" className="font-semibold text-white">{eyebrow}</span>
        </nav>
        <Reveal><div className="mt-10"><Eyebrow dark>{eyebrow}</Eyebrow></div></Reveal>
        <Reveal delay={0.05}><h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">{title}</h1></Reveal>
        <Reveal delay={0.1}><p className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">{text}</p></Reveal>
      </div>
    </section>
  );
};
